@if (headerBlock()) {
    @switch (headerBlock()!.type) {
        @case ("landing_page") {
            <packbo-landing-page [headerBlock]="headerBlock()" />
        }

        @case ("simple") {
            <packbo-simple-header [headerBlock]="headerBlock()" />
        }

        @case ("full") {
            <packbo-full-header [headerBlock]="headerBlock()" />
        }

        @case ("subscription") {
            <packbo-subscription-header [headerBlock]="headerBlock()" />
        }
    }
}
